// extracted by mini-css-extract-plugin
export var askAiIcon = "_oh-k";
export var category = "_oh-a";
export var categoryHeader = "_oh-f";
export var container = "_oh-0";
export var group = "_oh-b";
export var groupItems = "_oh-g";
export var groupSeparator = "_oh-l";
export var highlight = "_oh-8";
export var loading = "_oh-1";
export var noResults = "_oh-3";
export var placeholder = "_oh-2";
export var resultContent = "_oh-5";
export var resultIcon = "_oh-d";
export var resultItem = "_oh-h";
export var resultMeta = "_oh-9";
export var resultSubtitle = "_oh-7";
export var resultSuffix = "_oh-j";
export var resultTitle = "_oh-6";
export var resultsList = "_oh-4";
export var searchGroup = "_oh-e";
export var selected = "_oh-i";
export var subgroup = "_oh-c";